module.exports = __webpack_public_path__ + "assets/images/premium-features/unavailability-1-c0a443.svg";